import * as React from 'react';

export const InboxPage = React.lazy(() => import('./InboxPage'));
